export function requestBrowserNotificationPermission() {
  if (!('Notification' in window)) return;
  if (Notification.permission === 'default') {
    Notification.requestPermission();
  }
}

export function sendBrowserNotification(title, body) {
  if (!('Notification' in window)) return;
  if (Notification.permission === 'granted') {
    try {
      new Notification(title, { body, icon: '/logo-wakaana.png', badge: '/logo-wakaana.png' });
    } catch {}
  }
}

export function findLegacyDriverIdCookie() {
  const match = document.cookie.split(';').find((cookie) => cookie.trim().startsWith('wakaana_driver_id='));
  return match ? match.trim().split('=')[1] : null;
}

export function metersBetween(a, b) {
  if (!a || !b) return Infinity;
  const earthRadius = 6371000;
  const phi1 = a.lat * Math.PI / 180;
  const phi2 = b.lat * Math.PI / 180;
  const deltaPhi = (b.lat - a.lat) * Math.PI / 180;
  const deltaLambda = (b.lng - a.lng) * Math.PI / 180;
  const haversine = Math.sin(deltaPhi / 2) ** 2 + Math.cos(phi1) * Math.cos(phi2) * Math.sin(deltaLambda / 2) ** 2;
  return earthRadius * 2 * Math.atan2(Math.sqrt(haversine), Math.sqrt(1 - haversine));
}

export function getActiveDriverDeliveries(deliveries) {
  return deliveries.filter((delivery) => ['pending', 'transit'].includes(delivery.status));
}

export function sortActiveDriverDeliveries(deliveries) {
  return [...deliveries].sort((left, right) => {
    if (left.status === 'transit' && right.status !== 'transit') return -1;
    if (left.status !== 'transit' && right.status === 'transit') return 1;
    return new Date(left.created_at) - new Date(right.created_at);
  });
}


export function buildDriverDailySummary(deliveries) {
  const active = getActiveDriverDeliveries(deliveries);
  const totalToCollect = active.reduce((sum, d) => sum + (Number(d.amount) || 0), 0);

  const todayKey = new Date().toISOString().slice(0, 10);

  // Livrées / Retours du jour : basés sur delivered_at en base (fiable, pas localStorage)
  const todayDelivered = deliveries.filter(d =>
    d.status === 'delivered' && d.delivered_at && d.delivered_at.startsWith(todayKey)
  );
  const todayRetours = deliveries.filter(d =>
    d.status === 'failed' && d.delivered_at && d.delivered_at.startsWith(todayKey)
  );
  const todayAmount = todayDelivered.reduce((sum, d) => sum + (Number(d.amount) || 0), 0);

  // Historique = jours passés (delivered_at existe mais pas aujourd'hui)
  const historiqueItems = deliveries
    .filter(d =>
      ['delivered', 'failed'].includes(d.status) &&
      d.delivered_at &&
      !d.delivered_at.startsWith(todayKey)
    )
    .map(d => ({
      ...d,
      _completedAt: d.delivered_at.slice(0, 10),
      _completedStatus: d.status,
    }));

  return { active, totalToCollect, todayDelivered, todayRetours, todayAmount, historiqueItems };
}

export function groupDriverHistoryByDay(historiqueItems) {
  const todayStart = new Date();
  todayStart.setHours(0, 0, 0, 0);
  const yesterday = new Date(todayStart);
  yesterday.setDate(todayStart.getDate() - 1);

  const groups = [];
  const map = new Map();

  for (const delivery of historiqueItems) {
    const key = delivery._completedAt || (delivery.created_at ? new Date(delivery.created_at).toISOString().slice(0, 10) : 'unknown');
    if (!map.has(key)) {
      let label = 'Date inconnue';
      if (key !== 'unknown') {
        const date = new Date(key);
        const dayStart = new Date(date);
        dayStart.setHours(0, 0, 0, 0);
        if (dayStart >= yesterday) label = 'Hier';
        else label = date.toLocaleDateString('fr-FR', { weekday: 'long', day: 'numeric', month: 'long' });
      }
      const nextGroup = { label, key, items: [] };
      map.set(key, nextGroup);
      groups.push(nextGroup);
    }
    map.get(key).items.push(delivery);
  }

  // Du plus récent au plus ancien
  groups.sort((a, b) => b.key.localeCompare(a.key));
  return groups;
}

export function findParticulierProfile(profiles) {
  return profiles.find((profile) => profile.role === 'particulier') || null;
}
